import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home } from 'lucide-react';
import { handleInfo } from '../../../helper/bugsnag';
import { Header } from '../../organisms/Header/Header';

export function PageNotFound() {
  useEffect(() => {
    handleInfo('Page not found');
  }, []);

  return (
    <>
      <Header />
      <div className='mt-36 flex flex-col items-center justify-center p-6 text-center'>
        <AlertTriangle className='w-16 h-16 text-yellow-500 mb-4' />
        <h1 className='text-6xl font-bold text-gray-800 mb-2'>404</h1>
        <h2 className='text-2xl font-semibold text-gray-600 mb-4'>Seite nicht gefunden</h2>
        <p className='text-gray-500 mb-6'>
          Hoppla! Die gesuchte Seite existiert nicht. Sie wurde möglicherweise verschoben oder gelöscht.
        </p>
        <Link
          to='/'
          className='px-6 py-3 bg-primary text-white rounded-lg shadow hover:bg-primary-dark transition duration-300 ease-in-out flex items-center'
        >
          <Home className='w-4 h-4 mr-2' /> Zurück zur Dashboard
        </Link>
      </div>
    </>
  );
}
